<template>
  <div class="rank-con rank-flex-right">
    <div class="rank-title">
      <h3>课程排行</h3>
      <span @click="toRankCourse">查看更多 &gt;</span>
    </div>
    <div class="con-list f-clearfix">
      <ul class="rank-body rank-course f-clearfix">
        <li
          v-for="(item, index) in tableList"
          :key="index"
          :title="item.title"
          @click="toDetail(item)"
        >
          <!-- <a :href="item.ctUrl" target="_blank"> -->
          <div v-if="index > 2" class="item-index">
            <div>{{ index + 1 }}</div>
          </div>
          <div v-else class="item-index"></div>
          <div class="item-img">
            <img v-img.lazy="item.ctImgUrl" :alt="item.title" />
          </div>
          <div class="item-content">
            <h3 style="font-size: 14px">{{ item.name }}</h3>
            <div class="item-count">
              <span class="item-school">{{
                item.collegeTitle || item.schoolName
              }}</span>
            </div>
            <div class="item-count">
              <span class="item-edu"> {{ item.enrollCount || 0 }}人选课 </span>
            </div>
          </div>
          <!-- </a> -->
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      tableList: [],
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    toRankCourse() {
      window.open(`/course/rankIndex`);
    },
    toDetail(val) {
      window.open(val.ctUrl);
    },
    getList() {
      let par = {
        pageSize: 10,
        currentPage: 1,
      };
      this.$http
        .post("/api/web/course/rank", par)
        .then((res) => {
          this.tableList = res.data.records;
        })
        .catch((msg) => {
          console.log(msg);
        });
    },
  },
};
</script>
<style lang="scss">
.rank-con {
  background: #fff;
  border-radius: 4px;
  .rank-title {
    display: flex;
    justify-content: space-between;
    padding: 16px;
    border-bottom: solid 1px #eee;
    h3 {
      font-size: 16px;
      color: #666;
    }
    span {
      font-size: 14px;
      color: #999;
      cursor: pointer;
    }
  }
  .con-list {
    .rank-body {
      height: auto;
    }
  }
}
.rank-flex-right {
  background: #f7f8f9ff;
  padding-bottom: 20px;
  li {
    .item-img {
      width: 74px;
      height: 48px;
    }
    .item-content {
      min-width: 1px;
    }
  }
}
</style>
